import { render, staticRenderFns } from "./Claps.vue?vue&type=template&id=3545ce8a&lang=pug&"
import script from "./Claps.vue?vue&type=script&lang=ts&"
export * from "./Claps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports